module.exports = __webpack_public_path__ + "assets/img/717d57d8a031662da41c237254ebc984.png";